export class GetPaymentMethods {
  static type = '[PaymentMethods] Get';
}

export class GetPaymentMethodSecret {
  static type = '[PaymentMethods] Get Secret';
}

export class SetPaymentMethodAsDefault {
  static type = '[PaymentMethods] Set As Default';

  constructor(readonly paymentMethodId: string) {}
}

export class DeletePaymentMethod {
  static type = '[PaymentMethods] Delete';

  constructor(readonly paymentMethodId: string) {}
}
